(function () {
    "use strict";

    function loadYotpoScript() {
        if (!window.yotpoWidgetLoaded) {
            window.yotpoWidgetLoaded = true;
            var script = document.createElement("script");
            script.src = "https://staticw2.yotpo.com/WGQd8n6sWo4zTNGqOs6TY6qf6BGNZrV7rnrE6MPZ/widget.js";
            script.async = true;
            document.head.appendChild(script);
        }
    }

    function initYotpoObserver() {
        var elements = document.querySelectorAll(
            ".yotpo, .yotpo-pictures-widget, .yotpo-main-widget, [data-yotpo-product-id], #yotpo-reviews-banner"
        );

        if (elements.length) {
            if ("IntersectionObserver" in window) {
                var observer = new IntersectionObserver(
                    function (entries) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                loadYotpoScript();
                                observer.disconnect();
                            }
                        });
                    },
                    { rootMargin: "500px 0px" }
                );
                Array.prototype.forEach.call(elements, function (el) {
                    observer.observe(el);
                });
            } else {
                loadYotpoScript();
            }
        }
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initYotpoObserver);
    } else {
        initYotpoObserver();
    }
})();
